'use client'

import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { handleCMS } from "@/(front-desk)/store"
import { LoadingIcon, Pattern1 } from "@/(front-desk)/utils/patterns"
import { FacebookLink, TransportationLink } from "@/(front-desk)/(pages)/about/page"
import { reportError } from "@/(front-desk)/utils/functions"
import LanguageBtn from "@/(front-desk)/components/LanguageBtn"
import Transition from "@/(front-desk)/components/Transition"
import Marquee from "@/(front-desk)/components/Marquee"
import Markdown from "react-markdown"
import axios from "axios"


const LeftTitle = (props) => {
    return (
        <div className="left-title w-[4.375rem] flex flex-col items-center gap-3 shrink-0">
            <Pattern1 className="w-[1.5rem] fill-black-600" />
            <div className="flex-center w-[1.5rem] text-[0.75rem] text-black-600 font-light">
                {props.text}
            </div>
            <div className="w-[0.03rem] h-full bg-black-600"></div>
        </div>
    )
}

export default function informationAbout() {

    const dispatch = useDispatch()
    const language = useSelector((state) => state.global).language
    const infoAbout = useSelector((state) => state.CMS).infoAbout[language]

    useEffect(() => {
        if (language && !infoAbout) {
            axios.get(`/api/v1/cms/${language}/exhibition-info`)
            .then((res) => {
                // console.log(res.config?.url, res.data.body)
                dispatch(handleCMS.actions.setInfoAbout({
                    language: language,
                    data: res.data.body
                }))
            })
            .catch((err) => {
                // console.log(err.config?.url, err)
                reportError(err, true)
                
            })
        }
    }, [language])

    return (
        <>
        <title>參觀資訊 - 放視大賞</title>
        <main className="information-about flex flex-col justify-between">
            <div className="page-banner">
                <div className="page-banner-content flex flex-wrap gap-4 justify-between items-end">
                    <div className="">
                        <h1 className="title">About</h1>
                        <h2 className="sub-title">參觀資訊</h2>
                    </div>
                    <LanguageBtn />
                </div>
            </div>
            <Transition transitionKey={[infoAbout, language]}>
                { !infoAbout
                    ?
                    <div className="flex-center">
                        <LoadingIcon />
                    </div>
                    :
                    <div className="about-content flex flex-col gap-[5rem] mb-[10rem]">
                        <div className="section section-1 flex gap-[1.88rem]">
                            <LeftTitle text={language === 'en' ? 'Intro' : '展覽介紹'} />
                            <div id="information-about" className="whitespace-pre-wrap">
                                <Markdown>
                                    {infoAbout.content_md}
                                </Markdown>
                            </div>
                        </div>
                        <div className="section section-2 flex gap-[1.88rem]">
                            <LeftTitle text={language === 'en' ? 'Info' : '展出資訊'} />
                            <div className="items w-full">
                                { infoAbout.items?.map((item) => (
                                    <div
                                        key={`item-${item.id}`}
                                        className="item flex items-center gap-2 border-b border-black-700 py-[2.5rem]"
                                    >
                                        <div className="text-[1.5rem] text-main font-semibold w-[14rem] shrink-0">
                                            {item.title}
                                        </div>
                                        <div className="text-[1.125rem] text-white font-light whitespace-pre-wrap">
                                            {item.content_md}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <svg className="stars w-[4.3rem] h-fit" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 69" fill="none">
                                <path className="stroke-black-800" d="M56.1481 12.4841L56.2007 12.8671L56.5846 12.9126L65.7543 14L56.5846 15.0874L56.2007 15.133L56.1481 15.516L54.9395 24.3225L53.731 15.516L53.6784 15.133L53.2945 15.0874L44.1248 14L53.2945 12.9126L53.6784 12.8671L53.731 12.4841L54.9395 3.67755L56.1481 12.4841Z"/>
                                <path className="stroke-main" d="M32.7976 37.627L32.8498 38.0101L33.2337 38.056L55.6019 40.7273L33.2337 43.3987L32.8498 43.4446L32.7976 43.8277L29.9091 65.0242L27.0207 43.8277L26.9685 43.4446L26.5846 43.3987L4.2164 40.7273L26.5846 38.056L26.9685 38.0101L27.0207 37.627L29.9091 16.4305L32.7976 37.627Z"/>
                            </svg>
                        </div>
                        { infoAbout.booth_map_image &&
                            <div className="section section-3 flex gap-[1.88rem]">
                                <LeftTitle text={language === 'en' ? 'Booths' : '攤位資訊'} />
                                <div className="w-full">
                                    <img className="w-full" src={infoAbout.booth_map_image} />
                                </div>
                            </div>
                        }
                        <div className="section section-4 flex gap-[1.88rem]">
                            <TransportationLink language={language} />
                            <FacebookLink language={language} />
                        </div>
                    </div>
                }
            </Transition>
            <Marquee />
        </main>
        </>
    )
}